module.exports = __webpack_public_path__ + "images/locator/my_location-ee34c085.svg";